import React from 'react';
import { BrowserRouter as Router, Route, Switch, Link, useHistory } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import Reservation from './pages/Reservation';
import RoomSearch from './components/RoomSearch';
import Manager from './pages/Manager';
import Admin from './pages/Admin';
import ProtectedRoute from './components/ProtectedRoute';
import UserProfile from './components/UserProfile';
import Login from './components/Login';

function AppContent() {
  const { isAuthenticated, hasRole } = useAuth();
  const history = useHistory();

  const handleLogoClick = () => {
    history.push('/');
  };

  return (
    <div style={{
      background: `linear-gradient(135deg, rgba(36, 36, 36, 0.75) 0%, rgba(38, 38, 38, 0.75) 100%), url('/img/body-bg.jpg') no-repeat center center fixed`,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      minHeight: '100vh'
    }}>
      {/* Sticky Header */}
      <div 
        className="sticky-header"
        style={{
          background: `url('/img/header-bg.png') center center/cover, rgba(255, 255, 255, 0.6)`
        }}
      >
        <div className="sticky-header-content">
          {/* Logo - Left */}
          <div className="header-logo-section">
            <img
              src="/img/app-logo-alpha.png"
              alt="La Casita Logo"
              className="sticky-header-logo"
              onClick={handleLogoClick}
              style={{ cursor: 'pointer' }}
              title="Go to Home"
            />
          </div>
          
          {/* Main Title & Subtitle - Center */}
          <div className="header-title-section">
            <h1 className="sticky-header-main-title">Your Perfect Getaway Awaits</h1>
            <h2 className="sticky-header-sub-title">
              <em>Book your stay with ease. Find the perfect room for your family or group!</em>
            </h2>
          </div>
          
          {/* Navigation - Right */}
          <div className="header-nav-section">
            <div className="nav-links">
              {/* {!isAuthenticated() && (
                <Link to="/" style={{margin: '0 10px', color: '#4f8cff', textDecoration: 'none'}}>Home</Link>
              )} */}
              {isAuthenticated() && (hasRole('staff') || hasRole('manager') || hasRole('admin')) && (
                <Link to="/manager" style={{margin: '0 10px', color: '#4f8cff', textDecoration: 'none'}}>Manager</Link>
              )}
              {isAuthenticated() && hasRole('admin') && (
                <Link to="/admin" style={{margin: '0 10px', color: '#4f8cff', textDecoration: 'none'}}>Admin</Link>
              )}
              {!isAuthenticated() && (
                <Link 
                  to="/login" 
                  className="staff-login-link"
                  style={{margin: '0 10px', color: '#4f8cff', textDecoration: 'none'}}
                >
                  Staff Login
                </Link>
              )}
            </div>
            {isAuthenticated() && <UserProfile />}
          </div>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="main-content">
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/search-results" component={SearchResults} />
          <Route path="/reservation" component={Reservation} />
          <Route path="/login" render={() => {
            if (isAuthenticated()) {
              return (
                <div className="already-logged-in">
                  <h2>Already Logged In</h2>
                  <p>You are already logged in as {isAuthenticated() ? 'a staff member' : 'guest'}.</p>
                  <div style={{marginTop: '20px'}}>
                    {(hasRole('staff') || hasRole('manager') || hasRole('admin')) && (
                      <Link to="/manager" className="btn btn-primary" style={{marginRight: '10px'}}>
                        Go to Manager
                      </Link>
                    )}
                    {hasRole('admin') && (
                      <Link to="/admin" className="btn btn-primary">
                        Go to Admin
                      </Link>
                    )}
                  </div>
                </div>
              );
            }
            return <Login />;
          }} />
          <Route path="/manager" render={() => (
            <ProtectedRoute requiredRole="manager">
              <Manager />
            </ProtectedRoute>
          )} />
          <Route path="/admin" render={() => (
            <ProtectedRoute requiredRole="admin">
              <Admin />
            </ProtectedRoute>
          )} />
        </Switch>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;